export default __webpack_public_path__ + "static/media/greenscreen5.6b184fa0.jpg";